import { createSlice } from "@reduxjs/toolkit";
import { getRoleIdAPI } from "../../api/role";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getRoleIdSlice = createSlice({
  name: "getRoleId",
  initialState: data,
  reducers: {
   getRoleIdSlice(state) {
      state.isLoading = true;
    },
   getRoleIdSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getRoleIdSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getRoleIdSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getRoleIdHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(getRoleIdAction.getRoleIdSlice());
    const response: any = await getRoleIdAPI(id);
    
    dispatch(getRoleIdAction.getRoleIdSliceSuccess(response));
  } catch (e: any) {
    dispatch(getRoleIdAction.getRoleIdSliceFailure(e?.response?.data));
  }
};
export default getRoleIdSlice.reducer;
export const getRoleIdAction = getRoleIdSlice.actions;
